/**
 * Quiet companion line for blend navigation. Names jump to the partner row.
 */
function SynergyHint({
  selectedCount,
  singleSelectedName,
  suggestions,
  onJumpToFamily,
}) {
  if (!suggestions.length) return null;

  const subject =
    selectedCount === 1 && singleSelectedName
      ? singleSelectedName
      : 'Your blend';

  return (
    <p className="category-panel__synergy-tip" role="note">
      <span className="category-panel__synergy-tip-text">
        <span className="category-panel__synergy-subject">{subject}</span>
        {' pairs well with '}
        {suggestions.map((item, index) => {
          const isLast = index === suggestions.length - 1;
          const isSecondLast = index === suggestions.length - 2;
          let separator = '';
          if (!isLast) {
            if (suggestions.length === 2) separator = ' and ';
            else if (isSecondLast) separator = ', and ';
            else separator = ', ';
          }
          return (
            <span key={item.familyKey}>
              <button
                type="button"
                className="category-panel__synergy-link"
                onClick={() => onJumpToFamily(item.familyKey)}
              >
                {item.name}
              </button>
              {separator}
            </span>
          );
        })}
        .
      </span>
    </p>
  );
}

export default SynergyHint;
